import { GradientMesh } from '@/components/brand/GradientMesh';
import { TechPattern } from '@/components/brand/TechPattern';
import { Reveal } from '@/components/motion/Reveal';
import { Button } from '@/components/ui/Button';
import { usePageMeta } from '@/lib/usePageMeta';

export default function NotFound() {
  usePageMeta('Page not found');

  return (
    <section className="relative flex min-h-svh items-center overflow-hidden text-white">
      <GradientMesh />
      <TechPattern opacity={0.05} />
      <div className="shell relative z-10 py-32">
        <Reveal>
          <p className="font-display text-display-xl leading-none" style={{ fontStretch: '100%' }}>
            404
          </p>
          <h1 className="text-display-md mt-6 max-w-[16ch]">
            That page does not exist
          </h1>
          <p className="text-body-lg mt-5 max-w-[46ch] text-white/65">
            The link may be out of date, or the address slightly off. Everything else is still where
            you left it.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Button href="/" variant="inverse" size="lg">
              Back to home
            </Button>
            <Button href="/contact" variant="ghost" size="lg" className="text-white">
              Get in touch
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
